import React from "react";
import { motion } from "framer-motion";
import {
  FaHandshake,
  FaComments,
  FaMoneyBillWave,
  FaCreditCard,
} from "react-icons/fa";
import logo from "../assets/images/logo.png";

// Анимация заголовка
const titleVariants = {
  hidden: { opacity: 0, y: -10 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

// Анимация карточек (без смещения, только плавное появление)
const cardVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

// Анимация логотипа (плавное появление)
const logoVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

function StrategyBenefits() {
  const benefits = [
    { icon: <FaHandshake />, text: "Повний пакет стратегій та зв’язки" },
    {
      icon: <FaComments />,
      text: "Підтримка від овнерів, кураторів та тім-лідів 24/7",
    },
    {
      icon: <FaMoneyBillWave />,
      text: "Найпрофітніші зв’язки та гарантований заробіток",
    },
    {
      icon: <FaCreditCard />,
      text: "Виплати раз на 2 тижні (у випадку затримки коштів від рекламодавця виплачуємо самі)",
    },
  ];

  return (
    <section className="strategy">
      <div className="strategy__container">
        <motion.h2
          className="strategy__title"
          variants={titleVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.5 }}
        >
          Що ми надаEмо <span>нашим учням </span>
          та у командI:
        </motion.h2>

        <motion.div
          className="strategy__grid"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.4 }}
        >
          {/* Верхние два блока */}
          <motion.div className="strategy__card" variants={cardVariants}>
            <span className="strategy__number">01</span>
            <div className="strategy__icon">{benefits[0].icon}</div>
            <p className="strategy__text">{benefits[0].text}</p>
          </motion.div>

          <motion.div className="strategy__card" variants={cardVariants}>
            <span className="strategy__number">02</span>
            <div className="strategy__icon">{benefits[1].icon}</div>
            <p className="strategy__text">{benefits[1].text}</p>
          </motion.div>

          {/* Центральный логотип */}
          <motion.div className="strategy__logo" variants={logoVariants}>
            <img src={logo} alt="Логотип" />
          </motion.div>

          {/* Нижние два блока */}
          <motion.div className="strategy__card" variants={cardVariants}>
            <span className="strategy__number">03</span>
            <div className="strategy__icon">{benefits[2].icon}</div>
            <p className="strategy__text">{benefits[2].text}</p>
          </motion.div>

          <motion.div className="strategy__card" variants={cardVariants}>
            <span className="strategy__number">04</span>
            <div className="strategy__icon">{benefits[3].icon}</div>
            <p className="strategy__text">{benefits[3].text}</p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}

export default StrategyBenefits;
